import { useSecurityAuditSummary as useSecurityAuditSummaryQuery } from '@/modules/api/codegen';
import { silentQueryErrorMeta } from '@/modules/core/components/QueryProvider';

// An older self-hosted backend has no summary endpoint, so a failure only hides the indicator.
const SUMMARY_OPTIONS = { query: { meta: silentQueryErrorMeta } };

export const useSecurityAuditSummary = () => {
    const { data } = useSecurityAuditSummaryQuery(SUMMARY_OPTIONS);
    const summary = data?.data;

    const hasIssues = Boolean(summary && (summary.lowLevel || summary.highAge || summary.duplicities || summary.manyLeaks));

    return { summary, hasIssues };
};
